// Imports
import axios from 'axios';

// App imports
import { URL_API } from '../../../../../setup/config/env';

// Profile
export default function projects(groupId, refreshToken) {
  return axios.get(`${URL_API}/gitlab/userProjects`, {
    params: { id: groupId, token: refreshToken },
  });
}
